export default "__VITE_ASSET__BXqetoZa__"